module.exports = __webpack_public_path__ + "img/logo.5ddd6b22.png";